export const INITIALIZE_PRESS_PAGE = 'initialize-press-page';
const initializePressPage = () => ({ type: INITIALIZE_PRESS_PAGE });
export default initializePressPage;
